import { useContext, useEffect, useState } from "react";
import {
  Box, Button, MenuItem, FormControl, Grid, IconButton, InputLabel,
  Paper, Select, Stack, Table, TableBody, TableCell, Container,
  TableContainer, TableHead, InputBase, TableRow, styled,
  tableCellClasses, Pagination, TextField, InputAdornment,
  Typography, Divider, Backdrop, CircularProgress, Accordion,
  AccordionSummary, AccordionDetails
} from "@mui/material";
import { AlertType, SortType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import AddIcon from "@mui/icons-material/Add";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';
import { tableStyle } from "../parametrage/Pays/Pays";
import { DataRef } from "../../../types/DataRef";
import Cookies from "universal-cookie";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import OptionalWidthModal from "../../../commons/optional-width-modal/OptionalWidthModal";
import { AllMounth, PROFIL_DRC, yearsToDisplay } from "../../../constants/Constants";
import axios, { AxiosInstance } from "axios";
import { urlApi } from "../parametrage/Pays/RowPays";
import { SortParams } from "../production/SaisieAgent";
import { ColumnHeader, IYearsVerouillageClotureLocked } from "./ColumnHeader";
import BudgetRow from "./BudgetRow";
import CheckAttr from "../../../utils/CheckAttr";
import { BudgetData } from "../../../types/DataBudget";
import AddBudgetReforecastForm from "../../forms/Budget/AddBudgetReforecastForm";
import TabSort from "../../element/sort/TabSort";
import ExportBudget from "../../forms/Budget/ExportBudget";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { loggoutUser } from "../../../redux/actions/logginUser";
import { MediaQueryContext } from "../../../utils/contextes/MediaQueryContext";

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    textAlign: "center",
    fontSize: 11,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

export interface FilterParams {
  pays?: string;
  bu?: string;
  client?: string;
  operation?: string;
  month?: string;
  year?: string;
};

interface clientBudgetProd {
  id: number;
  libelle: string;
  is_clientBudget?: boolean
}

interface operationBudgetProd {
  id: number;
  libelle: string;
  is_operationBudget?: boolean
}

export const initialFilter: FilterParams = {
  pays: '',
  bu: '',
  client: '',
  operation: '',
  month: '',
  year: ''
};

export const initialDateVerouillageCloture: IYearsVerouillageClotureLocked = {
  YearsClotureBudget: []
  , YearsVerouillageBudget: []
}

export const profilsCanManageBudget = [
  PROFIL_DRC
];

const Budget = () => {
  const { isDesktopOrLaptop } = useContext(MediaQueryContext);

  const [page, setPage] = useState<number>(1);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [totalData, setTotalData] = useState<number>(0);
  const [sortedColumn, setSortedColumn] = useState<number>(0);

  // Data
  const [datasBudget, setDatasBudget] = useState<BudgetData[]>([]);

  // Autre
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openSnack, setOpenSnack] = useState<boolean>(false);
  const [expanded, setExpanded] = useState<number | false>(false);
  const [openExportModal, setOpenExportModal] = useState<boolean>(false);

  const [alertMessage, setAlerteMessage] = useState<string>("");
  const [articleSearch, setArticleSearch] = useState<string>("");
  const [alertType, setAlertType] = useState<AlertType>("success");

  const [dataPaysInAssociations, setDataPaysInAssociations] = useState<DataRef[]>([]);
  const [dataFilteredPays, setDataFilteredPays] = useState<DataRef[]>([]);
  const [dataBusinessUnits, setDataBusinessUnits] = useState<DataRef[]>([]);
  const [dataClients, setDataClients] = useState<clientBudgetProd[]>([]);
  const [dataOperations, setDataOperations] = useState<operationBudgetProd[]>([]);

  const [dateVerrouillageCloture, setDateVerrouillageCloture] = useState<IYearsVerouillageClotureLocked>(initialDateVerouillageCloture);

  const [columnToSort, setColumnToSort] = useState<SortParams | undefined>(
    undefined
  );

  const [filterParams, setFilterParams] = useState<FilterParams>(initialFilter);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const http: AxiosInstance = axios.create({
    baseURL: urlApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  // Add global response interceptor
  http.interceptors.response.use(
    (response) => {
      // Modify response data here, if needed
      return response;
    },
    (error) => {
      console.log(error.message);
      if (error.message === "Request failed with status code 401") {
        // Remove the redux store
        dispatch(loggoutUser());

        // Remove token in navigator cookies
        cookies.remove('jwt', { path: '/' });

        navigate("/sign-in");
      }
      return Promise.reject(error);
    }
  );

  let model = "Budget";
  let addTitle = "Ajout Budget";
  if (window.location.pathname === "/reforcaste") {
    model = "Reforcaste";
    addTitle = "Ajout Reforcaste";
  }

  const handleSearch = () => {
    // Recherche par article
    setPage(1);
    setRowsPerPage(5);
    getListBudget();
  };

  const reloadPage = () => {
    // setRefresh(!refresh);
    window.location.reload();
  };

  useEffect(() => {
  }, [window.location.pathname]);

  const handleClose = () => {
    setOpenModal(false);
  };

  const handleCloseAlert = () => {
    setOpenSnack(false);
  };

  const setSortParams = (column: string, order: SortType) => {
    setColumnToSort({
      column,
      orderBy: order,
    });
  };

  const iconToUse = (id: number): JSX.Element => {
    let icon = <ArrowUpwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
    if (sortedColumn === id) {
      if (columnToSort && columnToSort.orderBy === "DESC") {
        icon = <ArrowDownwardIcon sx={{ fontSize: 13, marginRight: 1 }} />;
      }
    }

    return icon;
  };

  const pagination: JSX.Element | boolean = (
    <Stack spacing={2} direction="row">
      <InputLabel sx={{ color: "#fff" }}>Lignes par page :</InputLabel>
      <FormControl variant="standard" sx={{ minWidth: 50 }}>
        <Select
          labelId="demo-simple-select-standard-label"
          id="demo-simple-select-standard"
          color="warning"
          sx={{ background: "#fff", borderRadius: 1, paddingLeft: 1 }}
          value={rowsPerPage}
          onChange={(e) => {
            setPage(1);
            setRowsPerPage(e.target.value as number);
          }}
          defaultValue={5}
        >
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={25}>25</MenuItem>
          <MenuItem value={50}>50</MenuItem>
        </Select>
      </FormControl>
      {!isLoading && totalData > rowsPerPage && (
        <Pagination
          count={Math.ceil(totalData / rowsPerPage)}
          color="standard"
          sx={{ button: { color: "white" } }}
          showFirstButton={true}
          showLastButton={true}
          siblingCount={0}
          boundaryCount={1}
          defaultPage={page}
          onChange={(event, value) => {
            setPage(value);

          }}
        />
      )}
    </Stack>
  );

  const stackAlert: JSX.Element = SnackBarAlert(
    openSnack,
    handleCloseAlert,
    alertType,
    alertMessage
  );

  // Function
  const getListBudget = async () => {
    setIsLoading(true);

    await http.post("budget/list", {
      articleSearch: articleSearch,
      rowsPerPage: rowsPerPage,
      page: page,
      model,
      clientIsBudget: dataClients?.find((cl) => cl.id === Number(filterParams.client))?.is_clientBudget
      , operationIsBudget: dataOperations?.find((op) => op.id === Number(filterParams.operation))?.is_operationBudget,
      filter: {
        pays: filterParams?.pays,
        bu: filterParams?.bu,
        client: filterParams?.client,
        operation: filterParams?.operation,
        mois: filterParams?.month,
        annee: filterParams?.year
      }
    }).then((res) => {
      const { total, data } = res.data;
      setTotalData(total);
      Array.isArray(data) && setDatasBudget(data);
    }).catch((error) => {
      console.log(error);
    }).finally(() => setIsLoading(false));
  };

  const getPaysByBudget = async () => {
    await http.post("budget/get/pays/by/model", { model })
      .then((res) => {
        Array.isArray(res.data) && setDataFilteredPays(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getBuByBudget = async () => {
    await http.post("budget/get/bu/by/model/pays", {
      pays: filterParams?.pays,
      model
    }).then((res) => {
      Array.isArray(res.data) && setDataBusinessUnits(res.data);
    }).catch((error) => {
      console.log(error);
    });
  }

  useEffect(() => {
    if (filterParams?.pays) {
      getBuByBudget();
    } else {
      setDataBusinessUnits([]);
      setDataClients([]);
      setDataOperations([]);
    }
  }, [filterParams?.pays]);

  useEffect(() => {
    if (filterParams?.bu) {
      getClientByBuPaysBudget();
    } else {
      setDataClients([]);
      setDataOperations([]);
    }
  }, [filterParams?.bu]);

  useEffect(() => {
    if (filterParams?.client) {
      getOperationByClientBuPaysBudget();
    } else {
      setDataOperations([]);
    }
  }, [filterParams?.client]);

  const handleChangeFilter = (e: any) => {
    const { name, value } = e.target;

    switch (name) {
      case "pays":
        setFilterParams({
          ...initialFilter,
          pays: value
        });
        break;
      case "bu":
        setFilterParams({
          ...filterParams,
          bu: value,
          client: '',
          operation: ''
        });
        break;
      case "client":
        setFilterParams({
          ...filterParams,
          client: value,
          operation: ''
        });
        break;
      case "operation":
        setFilterParams({
          ...filterParams,
          operation: value
        });
        break;
      default:
        setFilterParams({
          ...filterParams,
          [name]: value
        });
        break;
    }
  };

  const getClientByBuPaysBudget = async () => {
    await http.post("budget/get/client/prod-budget/by/model/pays/bu", {
      pays: filterParams?.pays,
      bu: filterParams?.bu,
      // model
    }).then((res) => {
      Array.isArray(res.data) && setDataClients(res.data);
    }).catch((error) => {
      console.log(error);
    });
  }

  const getOperationByClientBuPaysBudget = async () => {
    await http.post("budget/get/operation/prod-budget/by/model/pays/bu/client", {
      pays: filterParams?.pays,
      bu: filterParams?.bu,
      client: filterParams?.client,
      clientIsBudget: dataClients?.find((cl) => cl.id === Number(filterParams.client))?.is_clientBudget,
      // model
    }).then((res) => {
      Array.isArray(res.data) && setDataOperations(res.data);
    }).catch((error) => {
      console.log(error);
    });
  }

  const reloadList = (reloadMenuItem: boolean = true) => {
    getListBudget();

    if (reloadMenuItem) {
      getPaysByBudget();

      if (filterParams?.pays) {
        getBuByBudget();
      }

      if (filterParams?.pays && filterParams?.bu) {
        getClientByBuPaysBudget();
      }

      if (filterParams?.pays && filterParams?.bu && filterParams?.client) {
        getOperationByClientBuPaysBudget();
      }
    }
  }

  const getPaysInAssociation = () => {
    // Récupère tous les pays qui existe dans l'association pays-bu
    http.get('pivot-client-bu/get-all-exist-pays-in-association')
      .then(res => {
        Array.isArray(res.data) && setDataPaysInAssociations(res.data);
      }).catch(error => {
        console.log(error);
      });
  };

  const getDateVerouillaCloture = () => {
    // On Prend Le Date Veouillage et Date Cloture Now
    http.get('budget/get-year/verouillage-cloture-locked')
      .then(res => {
        setDateVerrouillageCloture(res.data);
      }).catch(error => {
        console.log(error);
      });
  }

  useEffect(() => {
    getListBudget();
  }, [filterParams, rowsPerPage, page, columnToSort]);

  useEffect(() => {
    // Get DateVerouillage DateCloture
    getDateVerouillaCloture();
    // Get Pays Des Budget
    getPaysByBudget();

    // Recupère les pays à utiliser dans le pop-up (selon le profil)
    getPaysInAssociation();

    getListBudget();
  }, [model]);

  const handleClose2 = () => {
    setOpenExportModal(false);
  };

  return (
    <>
      <Container maxWidth="xl">
        {isDesktopOrLaptop ? (
          <>
            <Grid container spacing={0.5} columns={{ xs: 6, sm: 10, md: 12 }}>
              <Grid item xs={6} sm={4} md={4.5} spacing={1.5}>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  color="warning"
                  sx={{ textTransform: "none", marginBottom: { xs: 2 } }}
                  onClick={() => setOpenModal(true)}
                >
                  Ajouter
                </Button>
                {/* <Button
                  variant="contained"
                  startIcon={<GetAppIcon />}
                  sx={{
                    textTransform: "none",
                    mb: { xs: 2 }, ml: 0.5,
                    color: "#fc8404",
                    background: "#fff",
                    '&:hover': {
                      backgroundColor: "#f5f5f5"
                    },
                  }}
                  onClick={() => setOpenExportModal(true)}
                >
                  Extraire
                </Button> */}
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(filterParams?.pays)}
                  >
                    Pays
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="pays"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Pays"
                    value={filterParams?.pays}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={0}></MenuItem>
                    {dataFilteredPays.map((pays) => (
                      <MenuItem key={pays?.id} value={pays?.id} dense>
                        {pays?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(filterParams?.bu)}
                  >
                    Business unit
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="bu"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Business unit"
                    value={filterParams?.bu}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem key={0} value={0}></MenuItem>
                    {dataBusinessUnits.map((bu) => (
                      <MenuItem key={bu?.id} value={bu?.id} dense>
                        {bu?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(filterParams?.client)}
                  >
                    Client
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="client"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Client"
                    value={filterParams?.client}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={0}></MenuItem>
                    {dataClients.map((client) => (
                      <MenuItem key={client?.id} value={client?.id} dense>
                        {client?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl fullWidth>
                  <InputLabel
                    id="demo-simple-select-label"
                    color="warning"
                    sx={{ mt: -1 }}
                    shrink={CheckAttr(filterParams?.operation)}
                  >
                    Opération
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="operation"
                    sx={{ background: "#fff" }}
                    size="small"
                    color="warning"
                    label="Opération"
                    value={filterParams?.operation}
                    onChange={handleChangeFilter}
                  >
                    <MenuItem value={0}></MenuItem>
                    {dataOperations.map((operation) => (
                      <MenuItem key={operation?.id} value={operation?.id} dense>
                        {operation?.libelle}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    htmlFor="Mois"
                    color="warning"
                    shrink={CheckAttr(filterParams?.month)}
                    sx={{ mt: -1 }}
                  >
                    Mois
                  </InputLabel>
                  <Select
                    id="Mois"
                    native
                    color="warning"
                    sx={{ background: "#fff" }}
                    size="small"
                    value={filterParams?.month}
                    name="month"
                    onChange={handleChangeFilter}
                    label="Mois"
                  >
                    <option value={0} ></option>
                    {AllMounth.map((m) => (
                      <option value={m.id}>{m.mounth}</option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={2} sm={2} md={1.25}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel
                    htmlFor="year"
                    color="warning"
                    shrink={CheckAttr(filterParams?.year)}
                    sx={{ mt: -1 }}
                  >
                    Année
                  </InputLabel>
                  <Select
                    id="year"
                    native
                    color="warning"
                    sx={{ background: "#fff" }}
                    size="small"
                    name="year"
                    value={filterParams?.year}
                    onChange={handleChangeFilter}
                    label="year"
                    inputProps={{
                      name: "year",
                    }}
                  >
                    <option value={0}></option>
                    {yearsToDisplay.map((y) => (
                      <option value={y}>{y}</option>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={0.5}
              columns={{ xs: 6, sm: 12, md: 12 }}
              sx={{ mt: 3 }}
            >
              <Grid item xs={6} sm={12} md={7}>
                <Box mt={2}>{pagination}</Box>
              </Grid>
              <Grid item xs={6} sm={12} md={5}>
                <Stack
                  direction="row"
                  spacing={3}
                  display="flex"
                  ml={3}
                  justifyContent="end"
                >
                  <InputBase
                    sx={{ color: "white" }}
                    value={articleSearch}
                    placeholder="Chercher un article ..."
                    onChange={(e) => setArticleSearch(e.target.value)}
                  />
                  <IconButton
                    type="button"
                    sx={{ p: "10px" }}
                    aria-label="search"
                    onClick={handleSearch}
                  >
                    <SearchIcon sx={{ color: "#fff" }} />
                  </IconButton>
                  <IconButton
                    aria-label="refresh"
                    sx={{ color: "#fff", pt: 0.5 }}
                    onClick={() => reloadPage()}
                  >
                    <RefreshIcon sx={{ fontSize: 35 }} />
                  </IconButton>
                </Stack>
              </Grid>
            </Grid>

            <TableContainer component={Paper} style={tableStyle}>
              <Table>
                <TableHead>
                  <TableRow>
                    {ColumnHeader.map((column) => (
                      <TabSort
                        key={column.id}
                        column={column}
                        icon={iconToUse(column.id)}
                        sortedColumn={sortedColumn}
                        setSortParams={setSortParams}
                        setSortedColumn={setSortedColumn}

                      />
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {totalData > 0 ? (
                    datasBudget.map((budget) => (
                      <BudgetRow
                        key={budget?.id}
                        model={model}
                        reloadList={reloadList}
                        budget={budget}
                        http={http}
                        expanded={expanded}
                        isDesktopOrLaptop={isDesktopOrLaptop}
                        setExpanded={setExpanded}
                        setAlertType={setAlertType}
                        setAlerteMessage={setAlerteMessage}
                        setOpenSnack={setOpenSnack}
                        dateVerrouillageCloture={dateVerrouillageCloture}
                      />
                    ))) : (
                    <StyledTableCell colSpan={12}>
                      Aucun resultat a été trouvé ...
                    </StyledTableCell>
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            <Box display='flex' justifyContent='right' mt={4}>
              {pagination}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{
              position: 'fixed',
              width: '95%',
              top: '10.32rem',
              pr: 1.5,
              pt: 2,
              bgcolor: '#080d24',
              zIndex: 1000
            }}>
              <Button
                variant="contained"
                size="small"
                startIcon={<AddIcon />}
                color="warning"
                fullWidth
                sx={{ textTransform: "none" }}
                onClick={() => setOpenModal(true)}
              >
                Ajouter
              </Button>
              <Button
                variant="contained"
                size="small"
                startIcon={<GetAppIcon />}
                sx={{
                  textTransform: "none",
                  color: "#fc8404",
                  background: "#fff",
                  mt: 0.5,
                  mb: 2
                }}
                fullWidth
                onClick={() => setOpenExportModal(true)}
              >
                Extraire
              </Button>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ArrowDropDownIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  Filtre
                </AccordionSummary>
                <AccordionDetails>
                  <FormControl sx={{ mt: 2.5 }} fullWidth>
                    <InputLabel
                      id="demo-simple-select-label"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filterParams?.pays) && "Pays"}
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      sx={{ background: "#fff" }}
                      size="small"
                      color="warning"
                      label="Pays"
                      name="pays"
                      value={filterParams?.pays}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataFilteredPays.map((pays) => (
                        <MenuItem key={pays?.id} value={pays?.id} dense>
                          {pays?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="bu" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filterParams?.bu) && "Business unit"}
                    </InputLabel>
                    <Select
                      labelId="bu"
                      id="demo-simple-select"
                      sx={{ background: "#fff" }}
                      size="small"
                      color="warning"
                      label="Business unit"
                      name="bu"
                      value={filterParams?.bu}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataBusinessUnits.map((bu) => (
                        <MenuItem key={bu?.id} value={bu?.id} dense>
                          {bu?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="client" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filterParams?.client) && "Client"}
                    </InputLabel>
                    <Select
                      labelId="client"
                      id="demo-simple-select"
                      sx={{ background: "#fff" }}
                      size="small"
                      color="warning"
                      label="Client"
                      name="client"
                      value={filterParams?.client}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataClients.map((client) => (
                        <MenuItem key={client?.id} value={client?.id} dense>
                          {client?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="operation" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filterParams?.operation) && "Opération"}
                    </InputLabel>
                    <Select
                      labelId="operation"
                      id="demo-simple-select"
                      sx={{ background: "#fff" }}
                      size="small"
                      color="warning"
                      label="Opération"
                      name="operation"
                      value={filterParams?.operation}
                      onChange={handleChangeFilter}
                    >
                      <MenuItem value="" dense></MenuItem>
                      {dataOperations.map((operation) => (
                        <MenuItem key={operation?.id} value={operation?.id} dense>
                          {operation?.libelle}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel id="month" color="warning" sx={{ mt: -1 }}>
                      {!CheckAttr(filterParams?.month) && "Mois"}
                    </InputLabel>
                    <Select
                      id="month"
                      native
                      color="warning"
                      sx={{ background: "#fff" }}
                      size="small"
                      value={filterParams?.month}
                      name="month"
                      onChange={handleChangeFilter}
                      label="Mois"
                    >
                      <option value={0} ></option>
                      {AllMounth.map((m) => (
                        <option value={m.id}>{m.mounth}</option>
                      ))}
                    </Select>
                  </FormControl>

                  <FormControl sx={{ mt: 0.1 }} fullWidth>
                    <InputLabel
                      htmlFor="year"
                      color="warning"
                      sx={{ mt: -1 }}
                    >
                      {!CheckAttr(filterParams?.year) && "Année"}
                    </InputLabel>
                    <Select
                      id="year"
                      native
                      color="warning"
                      sx={{ background: "#fff" }}
                      size="small"
                      name="year"
                      value={filterParams?.year}
                      onChange={handleChangeFilter}
                      label="year"
                      inputProps={{
                        name: "year",
                      }}
                    >
                      <option value={0}></option>
                      {yearsToDisplay.map((y) => (
                        <option value={y}>{y}</option>
                      ))}
                    </Select>
                  </FormControl>
                </AccordionDetails>
              </Accordion>

              <TextField
                id="outlined-basic"
                variant="outlined"
                sx={{
                  display: { xs: "flex", sm: "flex", md: "none" },
                  bgcolor: "#fff",
                  borderRadius: 1,
                  mt: 1,
                  mb: 3
                }}
                placeholder="Chercher un article ..."
                size="small"
                fullWidth
                value={articleSearch}
                onChange={(e) => setArticleSearch(e.target.value)}
                color="warning"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        type="button"
                        aria-label="search"
                        onClick={() => handleSearch()}
                      >
                        <SearchIcon />
                      </IconButton>
                      <IconButton aria-label="refresh" onClick={() => reloadPage()}>
                        <ClearIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <Typography>{(model === 'Budget') ? 'Liste budget par client' : `Liste ${model}`}</Typography>
              <Divider orientation="horizontal" sx={{ bgcolor: "#fff", mb: 2 }} />

              {!isLoading && totalData > rowsPerPage && (
                <Box display="flex" justifyContent="end">
                  <Pagination
                    count={Math.ceil(totalData / rowsPerPage)}
                    size="small"
                    color="standard"
                    sx={{ button: { color: "white" }, mb: 2 }}
                    showFirstButton={true}
                    showLastButton={true}
                    siblingCount={0}
                    boundaryCount={1}
                    defaultPage={page}
                    onChange={(event, value) => setPage(value)}
                  />
                </Box>
              )}
            </Box>

            <Box mt='17.5rem'>
              {datasBudget.map((budget) => (
                <BudgetRow
                  key={budget?.id}
                  model={model}
                  reloadList={reloadList}
                  budget={budget}
                  http={http}
                  expanded={expanded}
                  isDesktopOrLaptop={isDesktopOrLaptop}
                  setExpanded={setExpanded}
                  setAlertType={setAlertType}
                  setAlerteMessage={setAlerteMessage}
                  setOpenSnack={setOpenSnack}
                  dateVerrouillageCloture={dateVerrouillageCloture}
                />
              ))}
            </Box>

            <Stack direction="row" sx={{ mt: 3, mb: 4 }}>
              <InputLabel sx={{ color: "#fff", fontSize: 12, mt: 0.5 }}>
                Lignes par page :
              </InputLabel>
              <FormControl variant="standard" sx={{ minWidth: 48 }}>
                <Select
                  labelId="demo-simple-select-standard-label"
                  id="demo-simple-select-standard"
                  color="warning"
                  sx={{
                    background: "#fff",
                    borderRadius: 1,
                    paddingLeft: 1,
                    paddingTop: 0.5,
                    marginLeft: 1,
                    fontSize: 12,
                  }}
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(e.target.value as number)}
                  defaultValue={5}
                  size="small"
                >
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={25}>25</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          </>
        )}

        <OptionalWidthModal
          title={addTitle}
          breackPoint="lg"
          onClose={handleClose}
          open={openModal}
        >
          <AddBudgetReforecastForm
            dataPaysInAssociations={dataPaysInAssociations}
            http={http}
            model={model}
            onClose={handleClose}
            reloadList={reloadList}
            setOpenSnack={setOpenSnack}
            setAlerteMessage={setAlerteMessage}
            setAlertType={setAlertType}
            dateVerrouillageCloture={dateVerrouillageCloture}
          />
        </OptionalWidthModal>

        <OptionalWidthModal
          title={(model === "Reforcaste") ? "Export Reforcast" : "Export budget"}
          breackPoint="md"
          onClose={handleClose2}
          open={openExportModal}
        >
          <ExportBudget
            dataPaysInAssociations={dataPaysInAssociations}
            http={http}
            onClose={handleClose2}
            setOpenSnack={setOpenSnack}
            setAlerteMessage={setAlerteMessage}
            setAlertType={setAlertType}
          />
        </OptionalWidthModal>

        {stackAlert}

        <div>
          <Backdrop
            sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </Container>
    </>
  );
};

export default Budget;
